(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const config = JSON.parse(root.querySelector('[data-config]').textContent);
    let model = root.dataset.linha === 'pro' ? 'pro' : 'duo';
    let color = root.querySelector('[data-color]').dataset.color;
    root.querySelector('[data-coming]').textContent = config.products.some(p => p.available && Number(p.price) > 0) ? 'Disponível na iSafe' : 'Em breve na iSafe';
    const names = { pro: 'iPhone 18 Pro', max: 'iPhone 18 Pro Max', duo: 'iPhone Duo' };
    const image = root.querySelector('[data-choice-image]');
    function update() {
      const selectedColor = root.querySelector(`[data-color="${color}"]`);
      const colorName = selectedColor.dataset.name;
      root.querySelectorAll('[data-model]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.model === model)));
      root.querySelectorAll('[data-color]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.color === color)));
      root.querySelector('[data-color-name]').textContent = colorName;
      image.src = config.images[`${model}-${color}`];
      image.alt = `${names[model]} — ${colorName}`;
      root.querySelector('[data-selection]').textContent = image.alt;
      const matches = config.products.filter(p => p.model === model && p.available && Number(p.price) > 0 && normalize(p.title).includes(normalize(colorName)));
      const box = root.querySelector('[data-products]');
      box.hidden = !matches.length;
      root.querySelector('.inl-availability').hidden = !!matches.length;
      const list = box.querySelector('ul');
      list.replaceChildren();
      matches.forEach(p => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = p.url;
        a.textContent = `${p.title} — ${(p.price / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`;
        li.append(a); list.append(li);
      });
    }
    root.querySelectorAll('[data-model]').forEach(b => b.addEventListener('click', () => { model = b.dataset.model; update(); }));
    root.querySelectorAll('[data-color]').forEach(b => b.addEventListener('click', () => { color = b.dataset.color; update(); }));
    update();
    const frame = root.querySelector('[data-visor]');
    if (frame) {
      const origin = new URL(frame.src, location.href).origin;
      // FAIXA: dentro de um iframe o visor da Apple empurra o conteudo 720px para baixo.
      // E' de proposito: assim o 3D entra na tela (e comeca a carregar) antes de aparecer.
      // Sem tratar isso sobra um bloco preto entre o titulo da secao e o aparelho.
      const FAIXA = 720;
      // PALCO: altura do 3D mais o respiro de baixo, medida nos arquivos que estao no ar,
      // largura por largura de 320 a 1920 px. Muda so nos pontos de quebra da Apple, 1069 e
      // 735, e o Duo tem respiro menor que o Pro -- por isso a tabela e' por produto.
      const PALCO = { pro: [904, 840, 752], duo: [888, 816, 720] };
      const palco = (produto, l) => { const t = PALCO[produto] || PALCO.pro; return l >= 1069 ? t[0] : l >= 735 ? t[1] : t[2]; };
      const moldura = frame.parentElement;
      if (moldura) moldura.style.overflow = 'hidden';
      // A altura informada inclui o titulo do proprio visor ("Estrutura unibody"), que repete
      // o titulo da secao. A diferenca entre o informado e o palco E' esse titulo: recortamos
      // ele junto com a faixa. Se a diferenca sumir (visor republicado sem faixa e sem titulo),
      // nao recorta nada e usa a altura como veio.
      let ultima = 0, produto = 'pro';
      const ajusta = altura => {
        ultima = altura;
        const visivel = palco(produto, Math.round(frame.getBoundingClientRect().width) || window.innerWidth);
        const sobra = altura - visivel;
        const corte = sobra > 40 ? FAIXA + sobra : 0;
        const dentro = Math.min(4000, Math.max(300, sobra > 40 ? visivel : altura));
        frame.style.height = `${dentro + corte}px`;
        frame.style.marginTop = corte ? `-${corte}px` : '0px';
      };
      // antes da primeira medida so' a faixa e' conhecida
      frame.style.height = `${Math.round(frame.getBoundingClientRect().height) + FAIXA}px`;
      frame.style.marginTop = `-${FAIXA}px`;
      window.addEventListener('resize', () => { if (ultima) ajusta(ultima); }, { passive: true });
      const onMessage = event => {
        if (!root.isConnected) { window.removeEventListener('message', onMessage); return; }
        if (event.source !== frame.contentWindow || event.origin !== origin) return;
        if (event.data?.tipo === 'pv-3d-altura' && Number.isFinite(event.data.altura)) {
          if (event.data.produto && PALCO[event.data.produto]) produto = event.data.produto;
          ajusta(event.data.altura);
        }
      };
      window.addEventListener('message', onMessage);
      let last = 0;
      const onScroll = () => {
        if (!root.isConnected) { window.removeEventListener('scroll', onScroll); return; }
        if (Date.now() - last < 120) return;
        last = Date.now();
        frame.contentWindow?.postMessage({ tipo: 'pv-3d-rolou' }, origin);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      frame.addEventListener('load', () => frame.contentWindow.postMessage({ tipo: 'pv-3d-medir' }, origin));
    }
  }
  document.querySelectorAll('.inl').forEach(init);
  if (!window.isafeIphoneLinhaBound) {
    window.isafeIphoneLinhaBound = true;
    document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.inl').forEach(init));
  }
})();
